import { Env } from '../types/commons';

const validEnvs: Record<Env, boolean> = {
  development: true,
  staging: true,
  production: true,
};

let env: Env | undefined = process.env.NODE_ENV as Env;

export const initEnv = (value?: string) => {
  if (value && value in validEnvs) {
    env = value as Env;
  }
};

export const getEnv = () => env;

export const isDev = () => env === 'development';
export const isStaging = () => env === 'staging';
export const isProduction = () => env === 'production';
